var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0418 16.4691L15.6251 3.17741C14.9168 2.15658 13.7397 1.54199 12.5001 1.54199C11.2605 1.54199 10.0834 2.14616 9.34386 3.20866L0.968861 16.4482C-0.0936394 17.9691 -0.291556 19.792 0.448027 21.1982C1.17719 22.6045 2.70844 23.4066 4.62511 23.4066H20.3751C22.3022 23.4066 23.823 22.6045 24.5522 21.1982C25.2814 19.792 25.0834 17.9795 24.0418 16.4691ZM11.4584 7.79199C11.4584 7.21908 11.9272 6.75033 12.5001 6.75033C13.073 6.75033 13.5418 7.21908 13.5418 7.79199V14.042C13.5418 14.6149 13.073 15.0837 12.5001 15.0837C11.9272 15.0837 11.4584 14.6149 11.4584 14.042V7.79199ZM12.5001 20.292C11.6355 20.292 10.9376 19.5941 10.9376 18.7295C10.9376 17.8649 11.6355 17.167 12.5001 17.167C13.3647 17.167 14.0626 17.8649 14.0626 18.7295C14.0626 19.5941 13.3647 20.292 12.5001 20.292Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.b0717db20d1f13e581a114a00994eae0.svg";
export { ForwardRef as ReactComponent };